import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['card'];

  expand(event) {
    // Don't expand/collapse if this was triggered by form submission
    if (event?.type === 'submit') {
      return;
    }
    this.cardTarget.classList.toggle('expanded');
  }
}
